import React, { Component } from 'react';
import { StaticQuery, graphql } from "gatsby";
import get from 'lodash/get';
import Slider from 'react-slick';
import { getArticleOrCategorySlugs } from '../../utilities';
import { Image } from './../Common/Image';

class BrowserContentByCategory extends Component {
     constructor(props) {
          super(props);
          this.state = {
               activeCategory: this.props.topCategories[0].node.categoryName
          };
     }

     browseCategory = (e, categoryName) => {
          e.preventDefault();
          this.setState({ activeCategory: categoryName })
     }

     render() {
          const { titleBrowserContent } = this.props;
          const settings = {
               autoplay: false,
               dots: false,
               arrows: false,
               infinite: true,
               speed: 500,
               slidesToShow: 1,
          };
          var featuredArticles = [];
          var topCategories = this.props.topCategories;

          topCategories = [topCategories[3], topCategories[1], topCategories[2], topCategories[0], topCategories[4]];

          topCategories.forEach(({ node }) => {
               if (node.categoryName == this.state.activeCategory) {
                    featuredArticles = node.categoryFeaturedArticle;
               }
          })


          return (
               <section className={`home-browse`}>
                    <div className="container slider-container">
                         <h2>{titleBrowserContent}</h2>
                         <div className="desktop">
                              <div className="browse-title" role="tablist">
                                   {topCategories && topCategories.map(({ node }, i) => {
                                        if (i < 5) {
                                             return (
                                                  <a href="#"
                                                       className={this.state.activeCategory == node.categoryName ? 'active' : ''}
                                                       onClick={(e) => this.browseCategory(e, node.categoryName)} key={i}
                                                       role="tab"
                                                       aria-selected={this.state.activeCategory == node.categoryName ? 'true' : 'false'}
                                                  >
                                                       {node.categoryName}
                                                  </a>
                                             )
                                        }
                                   })}
                              </div>
                              <div className="browse-article">
                                   <div className="row">
                                        {featuredArticles && featuredArticles.map((featuredArticle, i) => {
                                             let slugs = '/healthzone/' + getArticleOrCategorySlugs(featuredArticle.category).reverse().join('/') + '/' + featuredArticle.slug + '/';

                                             return (
                                                  <div className="col-sm-3" key={i}>
                                                       <div className="article-detail">
                                                            <div className="image-wrap">
                                                                 <a href={slugs} tabIndex={-1}>
                                                                      {featuredArticle.featuredImage ? (<Image image={featuredArticle.featuredImage} altOverride={(featuredArticle.contentName) ? featuredArticle.contentName : ''} />) : <img src="/images/no-dog.png" alt="no-dog" />}
                                                                 </a>
                                                            </div>
                                                            <div className="content">
                                                                 <a href={slugs}>
                                                                      <h3>{featuredArticle.contentName}</h3>
                                                                 </a>
                                                                 {featuredArticle.shortDescription && <p>{featuredArticle.shortDescription}</p>}
                                                            </div>
                                                       </div>
                                                  </div>
                                             )
                                        })}
                                   </div>
                              </div>
                         </div>
                         <div className="mobile">
                              <div className="browse-title">
                                   <Slider variableWidth={true} {...settings}>
                                        {topCategories && topCategories.map(({ node }, i) => {
                                             if (i < 5) {
                                                  return (
                                                       <a href="#"
                                                            className={this.state.activeCategory == node.categoryName ? 'active' : ''}
                                                            onClick={(e) => this.browseCategory(e, node.categoryName)} key={i}
                                                       >
                                                            {node.categoryName}
                                                       </a>
                                                  )
                                             }
                                        })}
                                   </Slider>
                              </div>
                              <div className="browse-article">
                                   <Slider {...settings} variableWidth={true}
                                   // slidesToShow={(featuredArticles ? featuredArticles.length : 0)}
                                   // slidesToScroll={(featuredArticles ? featuredArticles.length : 0)}
                                   >
                                        {featuredArticles && featuredArticles.map((featuredArticle, i) => {
                                             let slugs = '/healthzone/' + getArticleOrCategorySlugs(featuredArticle.category).reverse().join('/') + '/' + featuredArticle.slug + '/';
                                             return (
                                                  <div className="article-detail" key={i}>
                                                       <div className="image-wrap">
                                                            <a href={slugs} tabIndex={-1}>
                                                                 {featuredArticle.featuredImage ? (<Image image={featuredArticle.featuredImage} />) : <img src="/images/no-dog.png" alt="no-dog" />}
                                                            </a>
                                                       </div>
                                                       <div className="content">
                                                            <a href={slugs}>
                                                                 <h3>{featuredArticle.contentName}</h3>
                                                            </a>
                                                            {featuredArticle.shortDescription && <p>{`${featuredArticle.shortDescription}`.substr(1, 120)}...</p>}
                                                       </div>
                                                  </div>
                                             )
                                        })}
                                   </Slider>
                              </div>
                         </div>
                    </div>
               </section>
          )
     }
}

export default () => {
     return <StaticQuery
          query={graphql`
               query BrowserContentByCategoryQuery {
                    allContentfulHzCategory(sort: {fields: createdAt}, filter: {isTopCategory: {eq: true}}) {
                         edges {
                              node {
                                   contentName
                                   contentful_id
                                   slug
                                   categoryName
                                   breadcrumbValue
                                   shortDescription
                                   featuredImage {
                                        ...ContentfulImageFields
                                   }
                                   categoryIntroImage {
                                        ...ContentfulImageFields
                                   }
                                   categoryFeaturedArticle {
                                        ...ContentfulHzArticleFields
                                   }
                                   ctaText
                                   parentCategory {
                                        slug
                                        parentCategory {
                                             slug
                                             parentCategory {
                                                  slug
                                                  parentCategory {
                                                       slug
                                                  
                                                  }
                                             }
                                        }
                                   }
                              }
                         }
                    }
                    titleBrowserContent : contentfulPage(contentful_id: {eq: "wChsWYdrCJ5doI8QdVkBk"}) {
                         id
                         rows {
                              ... on ContentfulSectionTitleBrowse {
                                id
                                contentName
                              }
                         }
                    }
               }
               
          `}
          render={
               data => {
                    const topCategories = get(data, 'allContentfulHzCategory.edges');
                    const titleBrowserContent = data.titleBrowserContent.rows[3].contentName;
                    return (
                         <BrowserContentByCategory titleBrowserContent={titleBrowserContent} topCategories={topCategories}></BrowserContentByCategory>
                    )
               }
          }
     />;
}
